import React, { useState, useMemo, useRef, useCallback, useContext, useEffect } from 'react';
import { Box, Typography, TextField, Slider, Chip, Tooltip, TablePagination } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import PlayArrowIcon from '@mui/icons-material/PlayCircleOutline';
import PauseIcon from '@mui/icons-material/PauseCircleOutline';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '../../Context/ThemeContext';
import AuthContext from '../../Context/AuthContext';
import { DARKCOLORS, LIGHTCOLORS } from '../../Utils/constants';
import './Academy.css';

import mapsection from "../../assets/Academy/home/Map_machine_location.mp4"
import homequick from "../../assets/Academy/home/dashboard_quick_access.mp4"
import profile from "../../assets/Academy/home/profile_section.mp4"
import theme from "../../assets/Academy/home/theme_notification_langauge.mp4"

import helpdocs from "../../assets/Academy/help/helpdocs.mp4"

import service_request from "../../assets/Academy/maintainence/service_request.mp4"

import tax1 from "../../assets/Academy/tax/tax1.mp4"
import tax2 from "../../assets/Academy/tax/tax2.mp4"
import tax3 from "../../assets/Academy/tax/tax3.mp4"


import sales1 from "../../assets/Academy/view/sales1.mp4"
import sales2 from "../../assets/Academy/view/sales2.mp4"
import sales3 from "../../assets/Academy/view/sales3.mp4"
import sales4 from "../../assets/Academy/view/sales4.mp4"

import Advertisment1 from "../../assets/Academy/manage/advertisment/Advertisment1.mp4"
import Advertisment2 from "../../assets/Academy/manage/advertisment/Advertisment2.mp4"

import coupons1 from "../../assets/Academy/manage/coupons/coupons1.mp4"
import coupons2 from "../../assets/Academy/manage/coupons/coupons2.mp4"
import coupons3 from "../../assets/Academy/manage/coupons/coupons3.mp4"

import discount1 from "../../assets/Academy/manage/discounts/discount1.mp4"
import discount2 from "../../assets/Academy/manage/discounts/discount2.mp4"
import discount3 from "../../assets/Academy/manage/discounts/discount3.mp4"
import discount4 from "../../assets/Academy/manage/discounts/discount4.mp4"

import machines1 from "../../assets/Academy/manage/machines/machines1.mp4"
import machines2 from "../../assets/Academy/manage/machines/machines2.mp4"
import machines3 from "../../assets/Academy/manage/machines/machines3.mp4"
import machines4 from "../../assets/Academy/manage/machines/machines4.mp4"

import Inventory1 from "../../assets/Academy/manage/Inventory/Inventory1.mp4"
import Inventory2 from "../../assets/Academy/manage/Inventory/Inventory2.mp4"
import Inventory3 from "../../assets/Academy/manage/Inventory/Inventory3.mp4"
import Inventory4 from "../../assets/Academy/manage/Inventory/Inventory4.mp4"

import user1 from "../../assets/Academy/manage/user/user1.mp4"

import machineVideo1 from "../../assets/Academy/machines/Video1.mp4"
import machineVideo2 from "../../assets/Academy/machines/Video2.mp4"
import machineVideo3 from "../../assets/Academy/machines/Video3.mp4"
import machineVideo4 from "../../assets/Academy/machines/Video4.mp4"
import machineVideo5 from "../../assets/Academy/machines/Video5.mp4"
import machineVideo6 from "../../assets/Academy/machines/Video6.mp4"
import machineVideo7 from "../../assets/Academy/machines/Video7.mp4"
import machineVideo8 from "../../assets/Academy/machines/Video8.mp4"
import machineVideo9 from "../../assets/Academy/machines/Video9.mp4"
import machineVideo10 from "../../assets/Academy/machines/Video10.mp4"
import machineVideo11 from "../../assets/Academy/machines/Video11.mp4"


// import theme from "../../assets/Academy/home/theme_notification_langauge.mp4"
// import theme from "../../assets/Academy/home/theme_notification_langauge.mp4"





// Video data with imported video files
const videosData = [
    // Home
    { id: 1, titleKey: 'academy.videoDashboardQuickAccess', duration: '1:30', category: 'Home', videoSrc: homequick },
    { id: 2, titleKey: 'academy.videoProfileManagement', duration: '2:15', category: 'Home', videoSrc:   profile},
    { id: 3, titleKey: 'academy.videoThemeNotificationsLanguage', duration: '1:45', category: 'Home', videoSrc: theme },
    { id: 4, titleKey: 'academy.videoCloudMapNavigation', duration: '1:45', category: 'Home', videoSrc: mapsection },

   
    // Maintenance
    { id: 6, titleKey: 'academy.videoCreateMachineServiceRequest', duration: '1:45', category: 'Maintenance', videoSrc: service_request },

    // Taxes
    { id: 7, titleKey: 'academy.videoGenerateTaxReports', duration: '1:45', category: 'Taxes', videoSrc: tax1 },
    { id: 8, titleKey: 'academy.videoUpdateTaxCycle', duration: '1:45', category: 'Taxes', videoSrc: tax2 },
    { id: 9, titleKey: 'academy.videoDownloadTaxReports', duration: '1:45', category: 'Taxes', videoSrc: tax3 },

    // Sales
    { id: 10, titleKey: 'academy.videoViewSalesReports', duration: '1:45', category: 'Sales', videoSrc: sales1 },
    { id: 11, titleKey: 'academy.videoTrackCouponsDiscounts', duration: '1:45', category: 'Sales', videoSrc: sales3 },
    { id: 12, titleKey: 'academy.videoCheckBestSellingProducts', duration: '1:45', category: 'Sales', videoSrc: sales4 },
    { id: 42, titleKey: 'academy.transaction', duration: '1:45', category: 'Sales', videoSrc: sales2 },

    // Manage - Advertisements
    { id: 13, titleKey: 'academy.videoAddAdvertisements', duration: '1:45', category: 'Manage', videoSrc: Advertisment1 },
    { id: 14, titleKey: 'academy.videoManageAdvertisements', duration: '1:45', category: 'Manage', videoSrc: Advertisment2 },

    // Manage - Coupons
    { id: 15, titleKey: 'academy.videoCreateCoupon', duration: '1:45', category: 'Manage', videoSrc: coupons1 },
    { id: 16, titleKey: 'academy.videoDeleteCoupons', duration: '1:45', category: 'Manage', videoSrc: coupons2 },
    { id: 17, titleKey: 'academy.videoDownloadCouponReports', duration: '1:45', category: 'Manage', videoSrc: coupons3 },

    // Manage - Discounts
    { id: 18, titleKey: 'academy.videoDeleteDiscounts', duration: '1:45', category: 'Manage', videoSrc: discount1 },
    { id: 19, titleKey: 'academy.videoEditDiscounts', duration: '1:45', category: 'Manage', videoSrc: discount2 },
    { id: 20, titleKey: 'academy.videoExportDiscounts', duration: '1:45', category: 'Manage', videoSrc: discount3 },
    { id: 21, titleKey: 'academy.videoCreateDiscount', duration: '1:45', category: 'Manage', videoSrc: discount4 },

    // Manage - Machines
    { id: 22, titleKey: 'academy.videoAddRemoveAisleProducts', duration: '1:45', category: 'Manage', videoSrc: machines2 },
    { id: 23, titleKey: 'academy.videoConfigureFoodPreference', duration: '1:45', category: 'Manage', videoSrc: machines3 },
    { id: 24, titleKey: 'academy.videoManageMachineTemperature', duration: '1:45', category: 'Manage', videoSrc: machines1 },
    { id: 25, titleKey: 'academy.videoAddMultipleProducts', duration: '1:45', category: 'Manage', videoSrc: machines4 },

    // Manage - Inventory
    { id: 26, titleKey: 'academy.videoAddInventoryCategories', duration: '1:45', category: 'Manage', videoSrc: Inventory1 },
    { id: 27, titleKey: 'academy.videoAddDeleteInventoryProducts', duration: '1:45', category: 'Manage', videoSrc: Inventory2 },
    { id: 28, titleKey: 'academy.videoDeleteInventoryCategories', duration: '1:45', category: 'Manage', videoSrc: Inventory4 },
    { id: 29, titleKey: 'academy.videoUseInventoryFilters', duration: '1:45', category: 'Manage', videoSrc: Inventory3 },

    // Manage - Users
    { id: 30, titleKey: 'academy.videoAddUserAccess', duration: '1:45', category: 'Manage', videoSrc: user1 },


    // Machines
    { id: 31, titleKey: 'academy.videoIntroductionToSmartVendingMachineExperience', duration: '1:45', category: 'Machines', videoSrc: machineVideo1 },
    { id: 33, titleKey: 'academy.videoAutomatedFoodHeatingProcessOverview', duration: '1:45', category: 'Machines', videoSrc: machineVideo3 },
    { id: 35, titleKey: 'academy.videoSmartFoodStorageAndHeatingChamberOverview', duration: '1:45', category: 'Machines', videoSrc: machineVideo5 },
    { id: 36, titleKey: 'academy.videoSmartMachineProductMovementDemonstration', duration: '1:45', category: 'Machines', videoSrc: machineVideo6 },
    { id: 38, titleKey: 'academy.videoRefillingProductsInsideSmartVendingMachine', duration: '1:45', category: 'Machines', videoSrc: machineVideo8 },
    { id: 32, titleKey: 'academy.videoHowCustomersUseSmartFoodVendingSystem', duration: '1:45', category: 'Machines', videoSrc: machineVideo2 },
    { id: 37, titleKey: 'academy.videoAutomatedPizzaInventoryManagementOverview', duration: '1:45', category: 'Machines', videoSrc: machineVideo7 },
    { id: 34, titleKey: 'academy.videoPizzaPreparationAndInternalMachineOperation', duration: '1:45', category: 'Machines', videoSrc: machineVideo4 },
    { id: 39, titleKey: 'academy.videoMultiProductInventoryLoadingDemonstration', duration: '1:45', category: 'Machines', videoSrc: machineVideo9 },
    { id: 40, titleKey: 'academy.videoSmartFoodVendingMachineIntroduction', duration: '1:45', category: 'Machines', videoSrc: machineVideo10 },
    { id: 41, titleKey: 'academy.videoSmartInterfaceScreenOverview', duration: '1:45', category: 'Machines', videoSrc: machineVideo11 },

     // Help
    { id: 5, titleKey: 'academy.videoCloudSystemHelpDocumentation', duration: '1:45', category: 'Help', videoSrc: helpdocs },

];

const Academy = () => {
    const { t } = useTranslation();
    const { mode } = useThemeContext();
    const { user } = useContext(AuthContext);

    const isEmployee = user?.roles?.includes('ROLE_EMPLOYEE');
    const categoryKeyMap = {
        'All': 'academy.categoryAll',
        'Home': 'academy.categoryHome',
        'Maintenance': 'academy.categoryMaintenance',
        'Taxes': 'academy.categoryTaxes',
        'Sales': 'academy.categorySales',
        'Manage': 'academy.categoryManage',
        'Machines': 'academy.categoryMachines',
        'Help': 'academy.categoryHelp',
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [playingVideoId, setPlayingVideoId] = useState(null);
    const [volumes, setVolumes] = useState({});
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [showControls, setShowControls] = useState({});
    const [videoDurations, setVideoDurations] = useState({});
    const [videoTimes, setVideoTimes] = useState({});
    const [page, setPage] = useState(0); 
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const videoRefs = useRef({});
    const cardRefs = useRef({});

    const containerBackground = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
    const textColor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
    const bodyColor = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
    const inputBg = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
    const borderColor = mode === 'dark' ? DARKCOLORS.GreyScale20 : LIGHTCOLORS.GreyScale20;
    const chipBg = mode === 'dark' ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
    const activechipBg = mode === 'dark' ? DARKCOLORS.GreyScale30 : LIGHTCOLORS.GreyScale20;

    const categories = useMemo(() => {
        const roleFiltered = isEmployee
            ? videosData.filter(v => v.category !== 'Sales' && v.category !== 'Taxes')
            : videosData;
        const cats = ['All', ...new Set(roleFiltered.map(v => v.category))];
        return cats;
    }, [isEmployee]);

    const roleFilteredVideos = useMemo(() => {
        return isEmployee
            ? videosData.filter(v => v.category !== 'Sales' && v.category !== 'Taxes')
            : videosData;
    }, [isEmployee]);

    const filteredVideos = useMemo(() => {
        return roleFilteredVideos.filter(video => {
            const matchesSearch = t(video.titleKey).toLowerCase().includes(searchQuery.toLowerCase().trim());
            const matchesCategory = selectedCategory === 'All' || video.category === selectedCategory;
            return matchesSearch && matchesCategory;
        });
    }, [searchQuery, selectedCategory, t, roleFilteredVideos]);

    const paginatedVideos = useMemo(() => filteredVideos, [filteredVideos]);

    useEffect(() => {
        setPage(0);
    }, [filteredVideos]);

    const displayedVideos = useMemo(() => {
        const startIndex = page * rowsPerPage;
        return paginatedVideos.slice(startIndex, startIndex + rowsPerPage);
    }, [paginatedVideos, page, rowsPerPage]);

    const handlePageChange = (_, newPage) => {
        setPage(newPage);
        document.querySelector('.academy-video-grid')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleVideoClick = (videoId) => {
        const videoEl = videoRefs.current[videoId];
        if (!videoEl) return;
        
        if (playingVideoId === videoId) {
            videoEl.pause();
            setPlayingVideoId(null);
        } else {
            if (playingVideoId && videoRefs.current[playingVideoId]) {
                videoRefs.current[playingVideoId].pause();
            }
            videoEl.play();
            setPlayingVideoId(videoId);
        }
    };

    const toggleFullscreen = useCallback(async (videoId) => {
        const cardEl = cardRefs.current[videoId];
        if (!cardEl) return;

        try {
            if (!document.fullscreenElement) {
                await cardEl.requestFullscreen();
                setIsFullscreen(true);
            } else {
                await document.exitFullscreen();
                setIsFullscreen(false);
            }
        } catch (err) {
            console.error('Fullscreen error:', err);
        }
    }, []);

    const handleVolumeChange = useCallback((videoId, newValue) => {
        const videoEl = videoRefs.current[videoId];
        if (!videoEl) return;
        
        const volume = newValue / 100;
        videoEl.volume = volume;
        
        if (newValue > 0 && videoEl.muted) {
            videoEl.muted = false;
        }
        
        if (newValue === 0) {
            videoEl.muted = true;
        }
        
        setVolumes(prev => ({ ...prev, [videoId]: newValue }));
    }, []);

    const toggleMute = useCallback((videoId) => {
        const videoEl = videoRefs.current[videoId];
        if (!videoEl) return;
        
        if (videoEl.muted || videoEl.volume === 0) {
            const previousVolume = volumes[videoId] && volumes[videoId] > 0 ? volumes[videoId] : 50;
            videoEl.muted = false;
            videoEl.volume = previousVolume / 100;
            setVolumes(prev => ({ ...prev, [videoId]: previousVolume }));
        } else {
            videoEl.muted = true;
            videoEl.volume = 0;
            setVolumes(prev => ({ ...prev, [videoId]: 0 }));
        }
    }, [volumes]);

    const handleVideoDuration = useCallback((videoId, duration) => {
        const minutes = Math.floor(duration / 60);
        const seconds = Math.floor(duration % 60);
        const formattedDuration = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        setVideoDurations(prev => ({ ...prev, [videoId]: formattedDuration }));
    }, []);

    const handleTimeUpdate = useCallback((videoId, currentTime) => {
        setVideoTimes(prev => ({ ...prev, [videoId]: currentTime }));
    }, []);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <Box className='academy-container' sx={{ px: { xs: 1, sm: 1, md: 1.5 }, py: { xs: 1.5, sm: 2, md: 3 } }}>
            <Box
                className='academy-content'
                sx={{
                    minHeight: '85vh'
                }}
            >
                {/* Header with Search */}
                <Box className="academy-header" sx={{ mb: 3, display:'flex', justifyContent:'space-between' }}>
                    <Typography className='academy_title' variant="h4" sx={{ color: textColor,  }}>
                        {t('sidebar.academy')}
                    </Typography>

                    <Box className="academy-search-wrapper academmy_webiste" sx={{ display: 'flex', alignItems: 'center', gap: 1,backgroundColor:containerBackground,minWidth:"150px" }}>
                        <SearchIcon sx={{ color: bodyColor, fontSize: 20 }} />
                        <TextField
                            placeholder={t('academy.searchPlaceholder') || 'Search videos...'}
                            variant="standard"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            fullWidth
                            InputProps={{ disableUnderline: true }}
                            sx={{
                                input: { color: textColor, fontSize: 15 },
                                '& .MuiInputBase-root': { backgroundColor: 'transparent' },
                            }}
                        />

                    </Box>
                </Box>

                {/* Category Filters */}
                <Box className="academy-categories" sx={{ mb: 3, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {categories.map(cat => (
                        <Chip className="academy_categories_filter"
                            key={cat}
                            label={t(categoryKeyMap[cat])}
                            onClick={() => setSelectedCategory(cat)}
                            sx={{
                                backgroundColor: selectedCategory === cat ? activechipBg : containerBackground,
                                color: textColor,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    backgroundColor: activechipBg ,
                                }
                            }}
                        />
                    ))}
                </Box>
                
                <Box className="academy-search-wrapper academmy_mobile" sx={{ display: 'flex', alignItems: 'center', gap: 1,backgroundColor:containerBackground,minWidth:"150px" }}>
                        <SearchIcon sx={{ color: bodyColor, fontSize: 20 }} />
                        <TextField
                            placeholder={t('academy.searchPlaceholder') || 'Search videos...'}
                            variant="standard"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            fullWidth
                            InputProps={{ disableUnderline: true }}
                            sx={{
                                input: { color: textColor, fontSize: 15 },
                                '& .MuiInputBase-root': { backgroundColor: 'transparent' },
                            }}
                        />

                    </Box>

                {/* Video Grid */}
                {paginatedVideos.length > 0 ? (
                    <>
                        <Box className="academy-video-grid">
                            {displayedVideos.map(video => {
                            const isPlaying = playingVideoId === video.id;
                            const videoVolume = volumes[video.id] ?? 50;
                            const isMuted = videoVolume === 0;
                            const controlsVisible = showControls[video.id] !== false;
                            return (
                                <Box
                                    key={video.id}
                                    className="academy-video-card"
                                    ref={(el) => { cardRefs.current[video.id] = el; }}
                                    onMouseEnter={() => setShowControls(prev => ({ ...prev, [video.id]: true }))}
                                    onMouseLeave={() => setShowControls(prev => ({ ...prev, [video.id]: false }))}
                                    sx={{
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        position: 'relative',
                                    }}
                                >
                                    <Box className="academy-thumbnail" sx={{
                                        position: 'relative', aspectRatio: '16/9', backgroundColor: containerBackground,
                                        borderRadius: 4,
                                        overflow: 'hidden',
                                    }}
                                    onClick={() => handleVideoClick(video.id)}
                                    >
                                        <video
                                            ref={(el) => { videoRefs.current[video.id] = el; }}
                                            src={video.videoSrc}
                                            preload="metadata"
                                            muted={videoVolume === 0}
                                            playsInline
                                            onEnded={() => setPlayingVideoId(null)}
                                            onLoadedMetadata={(e) => handleVideoDuration(video.id, e.target.duration)}
                                            onTimeUpdate={(e) => handleTimeUpdate(video.id, e.target.currentTime)}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: video.category === 'Machines' ? 'contain' : 'fill',
                                                display: 'block',
                                            }}
                                        />
                                        
                                        {!isPlaying && (
                                            <Chip
                                                label={videoDurations[video.id] || video.duration || '0:00'}
                                                size="small"
                                                sx={{
                                                    position: 'absolute',
                                                    bottom: 8,
                                                    right: 8,
                                                    backgroundColor: containerBackground,
                                                    backdropFilter: 'blur(8px)',
                                                    color: textColor,
                                                    fontWeight: 500,
                                                    fontSize: 12,
                                                    height: 24,
                                                    '& .MuiChip-label': {
                                                        px: 1,
                                                    }
                                                }}
                                            />
                                        )}
                                        {!isPlaying && (
                                            <Box sx={{
                                                position: 'absolute',
                                                inset: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: 'rgba(0,0,0,0.2)',
                                                transition: 'background-color 0.3s ease',
                                                pointerEvents: 'none',
                                            }}>
                                                <PlayArrowIcon
                                                    sx={{
                                                        fontSize: 48,
                                                        color: 'rgba(255,255,255,0.9)',
                                                        transition: 'transform 0.3s ease',
                                                        '.academy-video-card:hover &': {
                                                            transform: 'scale(1.15)',
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        )}

                                        {isPlaying && controlsVisible && (
                                            <Box
                                                onClick={(e) => e.stopPropagation()}
                                                sx={{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 0.5,
                                                    px: 1.5,
                                                    py: 0.75,
                                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                                    backdropFilter: 'blur(4px)',
                                                    transition: 'opacity 0.3s ease',
                                                    zIndex: 2,
                                                }}
                                            >
                                                {/* Progress Bar */}
                                                <Slider
                                                    value={videoDurations[video.id] && videoRefs.current[video.id] 
                                                        ? ((videoTimes[video.id] || 0) / videoRefs.current[video.id].duration) * 100 
                                                        : 0}
                                                    onChange={(_, newValue) => {
                                                        const videoEl = videoRefs.current[video.id];
                                                        if (videoEl && videoEl.duration) {
                                                            const newTime = (newValue / 100) * videoEl.duration;
                                                            videoEl.currentTime = newTime;
                                                            setVideoTimes(prev => ({ ...prev, [video.id]: newTime }));
                                                        }
                                                    }}
                                                    onChangeCommitted={(_, newValue) => {
                                                        const videoEl = videoRefs.current[video.id];
                                                        if (videoEl && videoEl.duration) {
                                                            const newTime = (newValue / 100) * videoEl.duration;
                                                            videoEl.currentTime = newTime;
                                                            setVideoTimes(prev => ({ ...prev, [video.id]: newTime }));
                                                        }
                                                    }}
                                                    onClick={(e) => e.stopPropagation()}
                                                    onMouseDown={(e) => e.stopPropagation()}
                                                    sx={{
                                                        width: '100%',
                                                        height:'2px',
                                                        color: '#fff',
                                                        '& .MuiSlider-rail': {
                                                            backgroundColor: 'rgba(255,255,255,0.3)',
                                                            opacity: 1,
                                                        },
                                                        '& .MuiSlider-track': {
                                                            backgroundColor: '#fff',
                                                            border: 'none',
                                                        },
                                                        '& .MuiSlider-thumb': {
                                                            backgroundColor: '#fff',
                                                        },
                                                        '& .MuiSlider-valueLabel': {
                                                            display: 'none',
                                                        },
                                                    }}
                                                />

                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Box
                                                        onClick={() => handleVideoClick(video.id)}
                                                        sx={{
                                                            color: '#fff',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            '&:hover': { opacity: 0.8 },
                                                        }}
                                                    >
                                                        <PauseIcon sx={{ fontSize: 20 }} />
                                                    </Box>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            color: '#fff',
                                                            fontSize: 11,
                                                            fontWeight: 500,
                                                            minWidth: '80px',
                                                        }}
                                                    >
                                                        {formatTime(videoTimes[video.id] || 0)} / {videoDurations[video.id] || '0:00'}
                                                    </Typography>

                                                   

                                                    {/* Volume */}
                                                    <Box
                                                        onClick={(e) => e.stopPropagation()}
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 0.5,
                                                            flex: 1,
                                                            minWidth: 0,
                                                        }}
                                                    >
                                                        <Tooltip title={isMuted ? 'Unmute' : 'Mute'} arrow>
                                                            <Box
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleMute(video.id);
                                                                }}
                                                                onMouseDown={(e) => e.stopPropagation()}
                                                                sx={{
                                                                    color: '#fff',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    cursor: 'pointer',
                                                                    padding: '4px',
                                                                    borderRadius: '50%',
                                                                    transition: 'background-color 0.2s ease',
                                                                    '&:hover': { 
                                                                        opacity: 0.8,
                                                                        backgroundColor: 'rgba(255,255,255,0.1)',
                                                                    },
                                                                    '&:active': {
                                                                        transform: 'scale(0.95)',
                                                                    },
                                                                    flexShrink: 0,
                                                                }}
                                                            >
                                                                {isMuted ? <VolumeOffIcon sx={{ fontSize: 18 }} /> : <VolumeUpIcon sx={{ fontSize: 18 }} />}
                                                            </Box>
                                                        </Tooltip>
                                                        <Slider
                                                            value={videoVolume}
                                                            onChange={(_, val) => {
                                                                handleVolumeChange(video.id, val);
                                                                // Unmute if user adjusts volume slider while muted
                                                                if (isMuted && val > 0) {
                                                                    const videoEl = videoRefs.current[video.id];
                                                                    if (videoEl) {
                                                                        videoEl.muted = false;
                                                                    }
                                                                }
                                                            }}
                                                            onChangeCommitted={(_, val) => {
                                                                // Ensure volume is applied when dragging stops
                                                                const videoEl = videoRefs.current[video.id];
                                                                if (videoEl) {
                                                                    videoEl.volume = val / 100;
                                                                    if (val === 0) {
                                                                        videoEl.muted = true;
                                                                    } else {
                                                                        videoEl.muted = false;
                                                                    }
                                                                }
                                                            }}
                                                            onClick={(e) => e.stopPropagation()}
                                                            onMouseDown={(e) => e.stopPropagation()}
                                                            min={0}
                                                            max={100}
                                                            size="small"
                                                            sx={{
                                                                color: '#fff',
                                                                width: 80,
                                                                '& .MuiSlider-thumb': {
                                                                    width: 12,
                                                                    height: 12,
                                                                    backgroundColor: '#fff',
                                                                    '&:hover, &.Mui-focusVisible': {
                                                                        boxShadow: '0 0 0 8px rgba(255,255,255,0.16)',
                                                                    },
                                                                    '&.Mui-active': {
                                                                        width: 14,
                                                                        height: 14,
                                                                    },
                                                                },
                                                                '& .MuiSlider-track': {
                                                                    backgroundColor: '#fff',
                                                                    height: 4,
                                                                },
                                                                '& .MuiSlider-rail': {
                                                                    backgroundColor: 'rgba(255,255,255,0.3)',
                                                                    height: 4,
                                                                },
                                                                '& .MuiSlider-markLabel': {
                                                                    color: '#fff',
                                                                },
                                                            }}
                                                        />
                                                    </Box>

                                                    {/* Fullscreen */}
                                                    <Box
                                                        onClick={() => toggleFullscreen(video.id)}
                                                        sx={{
                                                            color: '#fff',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            '&:hover': { opacity: 0.8 },
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        <FullscreenIcon sx={{ fontSize: 20 }} />
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>

                                    {/* Video Info */}
                                    <Box sx={{ p: 2 }}>
                                        <Tooltip title={t(video.titleKey)} arrow>
                                            <Typography 
                                                className='Vedio_title' 
                                                variant="subtitle1" 
                                                sx={{ 
                                                    color: textColor,
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    lineHeight: 1.4,
                                                    maxHeight: '2.8em' // 2 lines * 1.4 line-height
                                                }}
                                            >
                                                {t(video.titleKey)}
                                            </Typography>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            );
                            })}
                        </Box>

                        {/* Pagination Controls */}
                        <TablePagination
                                component="div"
                                count={paginatedVideos.length}
                                page={page}
                                onPageChange={handlePageChange}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                labelRowsPerPage={t('academy.videosPerPage')}
                                
                                sx={{
                                    color: textColor,
                                    position:'relative',
                                    bottom:'0px !imp',
                                     display:'flex',
                                     justifyContent:'center',
                                     alignItems:'center',
                                    '& .MuiTablePagination-selectLabel': {
                                        color: textColor,
                                    },
                                    '& .MuiTablePagination-displayedRows': {
                                        color: textColor,
                                    },
                                    '& .MuiTablePagination-select': {
                                        color: textColor,
                                    },
                                    '& .MuiSvgIcon-root': {
                                        color: textColor,
                                    },
                                }}
                            />
                    </>
                ) : (
                    <Box className="academy-empty-state" sx={{ textAlign: 'center', py: 8 }}>
                        <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
                            {t('academy.noVideosFound') || 'No videos found'}
                        </Typography>
                        <Typography variant="body2" sx={{ color: bodyColor }}>
                            {t('academy.tryDifferentSearch') || 'Try a different search term or category'}
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Academy;
